import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { AppContext, User } from "../../../../context/appContext";
import { AdminListContext } from "../context/adminListContext";
import AdminListProps from "../interface/adminListProps";
import AdminProps from "../interface/adminProps";
import NoAdminsFoundMessage from "./noAdminsFoundMessage";
import OptionMenu from "./optionMenu";

const RenderList = (): React.JSX.Element => {
  const {
    adminList,
    search,
  }: {
    adminList: AdminListProps;
    search: string;
  } = React.useContext(AdminListContext);

  const { user }: { user: User } = React.useContext(AppContext);

  const searchFilter: AdminProps[] = adminList.data.filter(
    (admin: AdminProps) =>
      admin.firstName.toLowerCase().includes(search.toLowerCase()) ||
      admin.lastName.toLowerCase().includes(search.toLowerCase()) ||
      admin.email.toLowerCase().includes(search.toLowerCase())
  );

  if (searchFilter.length === 0) return <NoAdminsFoundMessage />;

  return (
    <React.Fragment>
      {searchFilter.map((admin: AdminProps) => (
        <Box
          key={admin.userId}
          sx={{
            backgroundColor: "#eeeeee",
            mb: 2,
            p: 2,
            borderRadius: 2,
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={6}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                {admin.lastName}, {admin.firstName}
                {Number(user.id) === admin.userId && " (Sie)"}
              </Typography>
              <Typography variant="body2">{admin.email}</Typography>
            </Grid>

            <Grid item xs={6} sm={3} md={4}>
              <Typography
                variant="caption"
                sx={{
                  fontWeight: "bold",
                }}
              >
                Weitere Rolle
              </Typography>
              <br />
              <Typography variant="body1">
                {admin.isCoach ? "Coach" : "-"}
              </Typography>
            </Grid>

            <Grid
              item
              xs={6}
              sm={3}
              md={2}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <OptionMenu admin={admin} />
            </Grid>
          </Grid>
        </Box>
      ))}
    </React.Fragment>
  );
};

export default RenderList;
